import React from "react";

import { PanelContext } from "core/decorators/Panel";
import { ILabelDefinition } from "./ILabel";
import Label from "./Label";

/**
 * {@link PanelContext} aware wrapper for {@link Label} that adds panel instance and panel id
 * as label instance overrides. For use in Panel components.
 *
 * @author chris
 */

type PanelLabelProps = ILabelDefinition;

export default (props: PanelLabelProps) => (
	<PanelContext.Consumer>
		{(ctx) => (
			<Label
				{...props}
				instances={
					ctx ? [...props.instances || [], ctx.instance, ctx.panelId] : props.instances
				}
			/>
		)}
	</PanelContext.Consumer>
);



// WEBPACK FOOTER //
// ./src/core/components/label/PanelLabel.tsx